import IAction from '@signageos/actions/dist/IAction';

export const UpdateSerialNumberSupport = 'Device.UpdateSerialNumberSupport';
export interface UpdateSerialNumberSupport extends IAction<typeof UpdateSerialNumberSupport> {
	supported: boolean;
}
